import { COMMUNICATION_SECTIONS } from "../components/GroupCommunication/communicationSetupChecks";

export type GroupTabState = {
  activeGroupTab: string;
  communicationSubTab: string;
};

const keyFor = (groupId: string | number, admin: boolean) =>
  `${admin ? "admin-" : ""}group-${groupId}-tabs`;

export const setGroupTabState = (
  groupId: string | number,
  state: GroupTabState,
  admin = false
) => {
  sessionStorage.setItem(keyFor(groupId, admin), JSON.stringify(state));
};

export const getGroupTabState = (
  groupId: string | number,
  admin = false
): GroupTabState | null => {
  try {
    const raw = sessionStorage.getItem(keyFor(groupId, admin));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.activeGroupTab) return null;
    return {
      activeGroupTab: String(parsed.activeGroupTab),
      communicationSubTab:
        String(parsed.communicationSubTab) ||
        COMMUNICATION_SECTIONS.documentTemplates,
    };
  } catch {
    return null;
  }
};

export const rememberCommunicationReturn = (
  groupId: string | number,
  editorType: string,
  admin = false
) => {
  setGroupTabState(
    groupId,
    {
      activeGroupTab: "communication",
      communicationSubTab:
        editorType === "Communication"
          ? COMMUNICATION_SECTIONS.emailTemplates
          : COMMUNICATION_SECTIONS.documentTemplates,
    },
    admin
  );
};
